export default "__VITE_ASSET__73191d55__"